import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDemandCustomerList = createAsyncThunk("fetchDemandCustomerList", async ({ page, limit, keyword }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const params = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: keyword ?? "",
	});

	const response = await axiosHttp.get(`/demand/list/customers?${params}`, config);

	return response.data.data;
});

const DemandCustomerListSlice = createSlice({
	name: "DemandCustomerListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDemandCustomerList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchDemandCustomerList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
			state.page = action.payload.currentPage;
			state.total = action.payload.total;
		});
		builder.addCase(fetchDemandCustomerList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default DemandCustomerListSlice.reducer;
